import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['spinner', 'replace']

  #formSubmitHandler
  static values = {
    hideText: {
      type: Boolean,
      default: false
    }
  }

  connect() {
    this.removeLoading = this.removeLoading.bind(this)

    if (this.element.tagName === 'BUTTON' || this.element.type === 'submit') {
      this.form = this.element.closest('form') || document.querySelector(`#${this.element.getAttribute('form')}`)

      if (this.form) {
        this.#formSubmitHandler = () => {
          this.element.setAttribute("data-loading", "true")
        }
        this.form.addEventListener("submit", this.#formSubmitHandler)
      }

      document.addEventListener('turbo:submit-end', this.removeLoading)
    } else if (this.element.tagName === 'A') {
      // Handle Turbo frame links
      this.element.addEventListener('click', () => {
        this.element.setAttribute("data-loading", "true")
      })

      document.addEventListener('turbo:frame-load', this.removeLoading)
      document.addEventListener('turbo:frame-render', this.removeLoading)
      // Handle full page navigation completion
      document.addEventListener('turbo:load', this.removeLoading)
    }

    // Clear loading state before page is cached (for browser back button)
    document.addEventListener('turbo:before-cache', this.removeLoading)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.#formSubmitHandler)
    document.removeEventListener('turbo:submit-end', this.removeLoading)
    document.removeEventListener('turbo:frame-load', this.removeLoading)
    document.removeEventListener('turbo:frame-render', this.removeLoading)
    document.removeEventListener('turbo:load', this.removeLoading)
    document.removeEventListener('turbo:before-cache', this.removeLoading)
  }

  removeLoading() {
    this.element.removeAttribute("data-loading")
  }

  show(e) {
    if (this.hasReplaceTarget) {
      this.replaceTarget.classList.add('hidden')
    }

    if (this.hideTextValue) {
      this.spinnerTarget.parentElement.classList.add('text-transparent')
    }

    this.spinnerTarget.classList.remove('hidden')
  }

  hide() {
    this.spinnerTarget.classList.add('hidden')
  }
}
